export default __webpack_public_path__ + "static/media/logo-mobile.00ea7fc9.svg";